/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Вложение
 */
export interface AttachmentForLetter {
  /** @format uuid */
  id?: string;
  categoryCode?: string;
}

/**
 * Связь письма и договора
 */
export interface LinkForLetter {
  /**
   * ИД договора, к которому привязываем письмо
   * @format uuid
   */
  documentId?: string;

  /** Тип договора */
  documentType?: string;
}

/**
 * Форма почтового ящика
 */
export interface MailMessageCreate {
  subject?: string;
  sender?: string;
  recipient?: string;
  messageText?: string;
  parentMessage?: string;

  /** Информация для SWIFT */
  swift?: Swift;
  savedAttachments?: AttachmentForLetter[];
  links?: LinkForLetter[];
  isImportant?: boolean;
}

/**
 * Информация для SWIFT
 */
export interface Swift {
  /** Тип сообщения SWIFT */
  type: string;

  /** SWIFT-код отправиткля */
  swiftSender?: string;

  /** SWIFT-код получателя */
  swiftRecipient?: string;

  /** Транзакционный референс */
  reference?: string;

  /** Референс связанного документа */
  relReference?: string;

  /**
   * Идентификатор исходного документа
   * @format uuid
   */
  relDocId?: string;

  /** Тип документа */
  relDocType?: string;
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Готовность файла */
  isReady?: boolean;

  /** Код категории вложения */
  categoryCode?: string;

  /** Наименование категории вложения */
  categoryName?: string;

  /** Имя файла */
  name?: string;

  /**
   * Размер файла
   * @format int64
   */
  size?: number;

  /** Код ошибки */
  error?: string;
}

/**
 * Информация об обработке письма сотрудником Банка
 */
export interface Control {
  /** ФИО сотрудника, взявшего письмо в обработку */
  employeeReceiveFIO?: string;

  /** ФИО сотрудника, который исполнил письмо */
  employeeFIO?: string;
}

/**
 * Детальная форма пересылки
 */
export interface ForwardResponse {
  fullName?: string;

  /** @format uuid */
  fwdSender?: string;

  /** @format date-time */
  fwdDate?: string;
  comment?: string;
}

/**
 * Связанное письмо
 */
export interface LinkMail {
  link?: string;
  name?: string;

  /** @format date-time */
  sendDate?: string;
}

/**
 * Форма почтового ящика
 */
export interface MailBox {
  /** @format uuid */
  id?: string;
  monolithUuid?: string;
  code?: string;
  name?: string;
  branch?: string;
  inn?: string;
  kpp?: string;
  branchCode?: string;
  timezone?: string;
  absId?: string;
}

/**
 * Детальная форма письма
 */
export interface MailMessageResponse {
  /** @format uuid */
  id: string;
  documentNumber?: string;

  /** @format date-time */
  createDate?: string;
  isRead?: boolean;

  /** Форма почтового ящика */
  sender?: MailBox;
  extId?: string;

  /** Форма почтового ящика */
  recipient?: MailBox;
  subject?: string;
  parentMessage?: string;
  state?: string;
  stateAuthor?: string;
  stateComment?: string;
  attachments?: Attachment[];
  signatures?: Signature[];
  permissions?: PermissionResponse[];

  /** Информация для SWIFT */
  swift?: Swift;
  type?: MailMessageType;
  isForward?: boolean;
  forward?: ForwardResponse[];

  /** @format uuid */
  mailGroupId?: string;
  mailType?: string;

  /** Информация об обработке письма сотрудником Банка */
  control?: Control;

  /** Связанное письмо */
  parent?: LinkMail;
  responses?: LinkMail[];
  links?: LinkForLetter[];

  /** @format date-time */
  sendDate?: string;
  isImportant?: boolean;
  text?: string;
}

export enum MailMessageType {
  INBOX = "INBOX",
  OUTBOX = "OUTBOX",
  DRAFT = "DRAFT",
}

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Подпись
 */
export interface Signature {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  documentId?: string;
  confirmType?: string;

  /** @format date-time */
  confirmDate?: string;

  /** @format uuid */
  delegateId?: string;
  delegateFio?: string;
  authoritySignature?: string;
  paycontrolId?: string;
  transactionId?: string;
  certNumber?: string;
  certIssuer?: string;
  employeeName?: string;

  /** @format date-time */
  signatureDate?: string;
}

/**
 * Ответ с количеством непрочитанных писем
 */
export interface MailMessageCountResponse {
  /** @format int64 */
  count?: number;
}

/**
 * Форма шаблона
 */
export interface Template {
  /** @format uuid */
  id?: string;
  templateName?: string;
  type?: string;

  /** Форма почтового ящика */
  mailBox?: MailBox;
  subject?: string;
  text?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

export interface SwiftFormat {
  /** Тип сообщения */
  type?: string;

  /** Наименование типа сообщения */
  name?: string;

  /** Английское наименование */
  latinName?: string;

  /** Признак приоритетности */
  priority?: boolean;

  /** Характеристика возможности добавить ссылку на другой документ */
  refDoc?: string;
}

/**
 * Ответ со списком данных
 */
export interface CommonResponse {
  hasMore: boolean;

  /** @format int32 */
  size: number;
  data: MailMessageResponse[];
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: PermissionResponse[];
}

export interface AttachmentResponse {
  fileName?: string;
  hash?: string;
  categoryCode?: string;
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = MailMessageCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * ККБ Письма
 */
export interface MailMessageCcb {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Вложения письма */
  attachments?: AttachmentResponse[];

  /**
   * Дата отправки
   * @format date-time
   */
  receiveDate?: string;

  /** Дата создания */
  documentDateTime?: string;

  /** Номер документа */
  documentNumber?: string;

  /** Идентификатор внешней системы */
  extId?: string;

  /** Тема письма */
  subject?: string;

  /** Текст письма */
  messageText?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Категория вложения
 */
export interface AttachCategory {
  /** Код категории */
  code?: string;

  /** Наименование категории */
  name?: string;
}

export interface SendParams {
  id?: string;
}

export interface GetMailMessageByIdParams {
  /**
   * Идентификатор письма для поиска
   * @format uuid
   */
  id: string;
}

export interface UnreadCountParams {
  senderCode?: string;
}

export interface GetTemplateByIdParams {
  /**
   * Идентификатор шаблона для поиска
   * @format uuid
   */
  id: string;
}

export interface GetTemplatesParams {
  /**
   * ИД почтового ящика Банка
   * @format uuid
   */
  mailBox?: string;
}

export interface GetSwiftFormatsParams {
  purpose?: string;
}

export interface SearchMailMessagesParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  text?: string;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  mailBox?: string;
  type: "INBOX" | "OUTBOX" | "DRAFT";
}

export interface GetPermissionsParams {
  documentType: string;
}

export interface GetExtBankMailBoxesParams {
  allBoxes?: boolean;
}

export interface GetLettersBySenderParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  senderCode: string;
}

export interface GetOrderCcbParams {
  documentId: string;
  documentType: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-mail
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-mail.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Письма
     * @name UpdateLetter
     * @summary Редактирование черновика
     * @request PUT:/api/mail/v1/external/{id}
     * @secure
     */
    updateLetter: (
      id: string,
      data: MailMessageCreate,
      params: RequestParams = {}
    ) =>
      this.request<MailMessageResponse, void>({
        path: `/api/mail/v1/external/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name Delete
     * @summary Удаление черновика
     * @request DELETE:/api/mail/v1/external/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<MailMessageResponse, void>({
        path: `/api/mail/v1/external/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name Send
     * @summary Отправка письма
     * @request POST:/api/mail/v1/external/send
     * @secure
     */
    send: (
      query: SendParams,
      data: MailMessageCreate,
      params: RequestParams = {}
    ) =>
      this.request<MailMessageResponse, void>({
        path: `/api/mail/v1/external/send`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name CreateLetter
     * @summary Создание черновика
     * @request POST:/api/mail/v1/external/create
     * @secure
     */
    createLetter: (data: MailMessageCreate, params: RequestParams = {}) =>
      this.request<MailMessageResponse, void>({
        path: `/api/mail/v1/external/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name UploadMultipartFile
     * @summary Загрузка файла Клиентом
     * @request POST:/api/mail/v1/external/attachment/upload
     * @secure
     */
    uploadMultipartFile: (data: { files: File }, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/mail/v1/external/attachment/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name GetMailMessageById
     * @summary Получение письма по идентификатору
     * @request GET:/api/mail/v1/external
     * @secure
     */
    getMailMessageById: (
      query: GetMailMessageByIdParams,
      params: RequestParams = {}
    ) =>
      this.request<MailMessageResponse, void>({
        path: `/api/mail/v1/external`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name Download
     * @summary Получение файла вложения
     * @request GET:/api/mail/v1/external/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<File, string[]>({
        path: `/api/mail/v1/external/${id}/download`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name UnreadCount
     * @summary Получение количества непрочитанных писем
     * @request GET:/api/mail/v1/external/unread
     * @secure
     */
    unreadCount: (query: UnreadCountParams, params: RequestParams = {}) =>
      this.request<MailMessageCountResponse, void>({
        path: `/api/mail/v1/external/unread`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name GetTemplateById
     * @summary Получение шаблона по идентификатору
     * @request GET:/api/mail/v1/external/templates
     * @secure
     */
    getTemplateById: (
      query: GetTemplateByIdParams,
      params: RequestParams = {}
    ) =>
      this.request<Template, void>({
        path: `/api/mail/v1/external/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name GetTemplates
     * @summary Получение списка шаблонов
     * @request GET:/api/mail/v1/external/templates/list
     * @secure
     */
    getTemplates: (query: GetTemplatesParams, params: RequestParams = {}) =>
      this.request<Template[], void>({
        path: `/api/mail/v1/external/templates/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SWIFT коды
     * @name GetSwiftFormats
     * @summary Получение справочника типов сообщений SWIFT
     * @request GET:/api/mail/v1/external/swift-code
     * @secure
     */
    getSwiftFormats: (
      query: GetSwiftFormatsParams,
      params: RequestParams = {}
    ) =>
      this.request<SwiftFormat[], void | GenericError>({
        path: `/api/mail/v1/external/swift-code`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name SearchMailMessages
     * @summary Получение списка писем по параметрам
     * @request GET:/api/mail/v1/external/search
     * @secure
     */
    searchMailMessages: (
      query: SearchMailMessagesParams,
      params: RequestParams = {}
    ) =>
      this.request<CommonResponse, void>({
        path: `/api/mail/v1/external/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name Print
     * @summary Печатная форма письма
     * @request GET:/api/mail/v1/external/print/{uuid}
     * @secure
     */
    print: (uuid: string, params: RequestParams = {}) =>
      this.request<File, void>({
        path: `/api/mail/v1/external/print/${uuid}`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name GetPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/mail/v1/external/permissions
     * @secure
     */
    getPermissions: (query: GetPermissionsParams, params: RequestParams = {}) =>
      this.request<PermissionListResponse, void>({
        path: `/api/mail/v1/external/permissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Почтовые ящики
     * @name GetExtBankMailBoxes
     * @summary Получение банковских почтовых ящиков
     * @request GET:/api/mail/v1/external/mail_boxes
     * @secure
     */
    getExtBankMailBoxes: (
      query: GetExtBankMailBoxesParams,
      params: RequestParams = {}
    ) =>
      this.request<MailBox[], void>({
        path: `/api/mail/v1/external/mail_boxes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name GetLettersBySender
     * @summary Получение списка писем по отправителю
     * @request GET:/api/mail/v1/external/incoming
     * @secure
     */
    getLettersBySender: (
      query: GetLettersBySenderParams,
      params: RequestParams = {}
    ) =>
      this.request<CommonResponse, void>({
        path: `/api/mail/v1/external/incoming`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/mail/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (query: GetOrderCcbParams, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, void>({
        path: `/api/mail/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/mail/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, void>({
        path: `/api/mail/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс управления сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/mail/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, void>({
        path: `/api/mail/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Категории вложений
     * @name GetAttachCategories
     * @summary Получение справочника категорий вложений
     * @request GET:/api/mail/v1/external/attachment/categories
     * @secure
     */
    getAttachCategories: (params: RequestParams = {}) =>
      this.request<AttachCategory[], GenericError>({
        path: `/api/mail/v1/external/attachment/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Письма
     * @name DeleteFileBeforeDraftCreation
     * @summary Удаление файла, загруженного клиентом
     * @request DELETE:/api/mail/v1/external/attachment/client-delete/{id}
     * @secure
     */
    deleteFileBeforeDraftCreation: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/mail/v1/external/attachment/client-delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
